// extracted by mini-css-extract-plugin
export var acitonButtons = "_m8-0";
export var additionalIcon = "_m8-f";
export var block = "_m8-1";
export var blockContent = "_m8-7";
export var blockDescription = "_m8-8";
export var blockIcon = "_m8-9";
export var blockTitle = "_m8-6";
export var border = "_m8-a";
export var center = "_m8-l";
export var edge = "_m8-b";
export var edgeLabel = "_m8-c";
export var edgePath = "_m8-d";
export var error = "_m8-e";
export var flowchart = "_m8-g";
export var flowchartContent = "_m8-h";
export var highlighted = "_m8-3";
export var hover = "_m8-4";
export var icon = "_m8-i";
export var left = "_m8-m";
export var navButton = "_m8-j";
export var navButtons = "_m8-k";
export var right = "_m8-n";
export var selected = "_m8-2";
export var small = "_m8-5";